import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Radio, Tabs, message } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateTripApproval,
  getRoles,
  tripApproval,
  updateTripApproval,
} from "../../../actions/companySettings";
import { headerTitles } from "../../../actions/masterdata/masterdata";
import { apis } from "../../../config/APIs";
import usePayAxios from "../../../config/useAxios";
import useSettings from "../../../config/useSettings";
import HirarchicalApproval from "./HirarchicalApproval";
import AdvancedApproval from "./AdvancedApproval";

const { TabPane } = Tabs;

message.config({
  maxCount: 3,
});

const ApprovalTrip = ({ hasWriteAccess }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [tripApprovalData, setTripApprovalData] = React.useState([]);
  const [rolesData, setRolesData] = React.useState([]);
  const tripApprovalResponse = useSelector(
    (state) => state.companySetting.tripApproval || {}
  );
  const updateTripApprovalResponse = useSelector(
    (state) => state.companySetting.updateTripApproval || {}
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {}
  );
  const [editMode, setEditMode] = React.useState(false);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const [showApproval, setShowApproval] = React.useState(false);
  const [showAdvancedApproval, setShowAdvancedApproval] = React.useState(false);
  const [radioVal, setRadioVal] = React.useState("hierarchical");
  const { onCall: updateOptions } = usePayAxios({
    api: apis.hierarchyUpdateOptions,
    method: "post",
  });
  const { data, onCall } = usePayAxios({
    api: apis.hierarchyOptions,
    method: "get",
  });
  const { data: { data: trip_approvals = [], status = false } = {} } =
    tripApprovalResponse;
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(tripApproval({ module_type: "TRIP_APPROVAL" }));
    dispatch(getRoles({}));
    dispatch(
      headerTitles({
        title: "trip_approval",
        description: "",
      })
    );
    onCall({
      params: {
        // module_type:"TRIP_APPROVAL"
        seed_type: "trips_hierarchy",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (status && trip_approvals) {
      setTripApprovalData(
        trip_approvals?.map((ele, idx) => ({ ...ele, level: idx }))
      );
      setSelectedRoles(trip_approvals.map((k) => k.role_id));

      // message.success(<span className="messageText">{res_message}</span>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripApprovalResponse]);

  React.useEffect(() => {
    if (
      data?.data?.[0]?.seed_value === "with hierarchy" &&
      data?.data?.[0]?.seed_code?.includes("_1")
    ) {
      setRadioVal("hierarchical");
    } else if (
      data?.data?.[0]?.seed_value === "Custom Approval Flow" &&
      data?.data?.[0]?.seed_code?.includes("_2")
    ) {
      setRadioVal("advanced");
    }
  }, [data]);

  // React.useEffect(() => {
  //   const { data: { response: { trip_approvals = [] } = {}, status = '', message: res_message = '', errors = '' } = {} } = updateTripApprovalResponse;
  //   if (status && trip_approvals) {
  //     setTripApprovalData(trip_approvals?.map((ele, idx) => ({ ...ele, level: idx })));
  //     setSelectedRoles(trip_approvals.map(k => k.role_id))
  //     setEditMode(false)
  //     message.success(<span className="messageText">{res_message}</span>);
  //     dispatch({
  //       type: UpdateTripApproval.RESET,
  //     });
  //   }
  //   else if (status === false) {
  //     message.error(<span className="messageText">{errors}</span>);
  //     dispatch({
  //       type: UpdateTripApproval.RESET,
  //     });

  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [updateTripApprovalResponse]);

  React.useEffect(() => {
    const {
      data: {
        data: trip_approvals = [],
        status = "",
        message: res_message = "",
        error = "",
      } = {},
    } = updateTripApprovalResponse;
    if (error === false) {
      dispatch(tripApproval({ module_type: "TRIP_APPROVAL" }));
      message.success(<span className="messageText">{res_message}</span>);
      setEditMode(false);
      dispatch({
        type: UpdateTripApproval.RESET,
      });
    } else if (status === false) {
      message.error(<span className="messageText">{res_message}</span>);
      dispatch({
        type: UpdateTripApproval.RESET,
      });
    }
  }, [updateTripApprovalResponse]);

  React.useEffect(() => {
    const { data: { data: roles = [], status = false } = {} } = rolesResponse;
    if (status) {
      setRolesData(roles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  const handleSubmit = () => {
    const dataArray = tripApprovalData.map(({ company_id, ...rest }) => rest);
    dispatch(
      updateTripApproval({
        data: [...dataArray],
        params: { module_type: "TRIP_APPROVAL" },
      })
    );
  };

  console.log(rolesResponse, "tripsData===>");
  const handleCancel = () => {
    setTripApprovalData(trip_approvals);
    setEditMode(false);
  };

  const handleApproveList = (type, key) => {
    if (type === "add") {
      setTripApprovalData([
        ...tripApprovalData,
        {
          can_approve_or_reject: false,
          can_reimburse: false,
          // id: tripApprovalData.length,
          level: tripApprovalData.length,
          role_name: "",
          is_active: true,
        },
      ]);
    } else {
      let idx = -1;
      const filterArray = tripApprovalData.map((obj, index) => {
        if (obj.level === key && obj?.id) {
          obj.is_active = false;
        } else if (obj.level === key) {
          idx = index;
        }
        return obj;
      });
      if (idx > -1) {
        filterArray.splice(idx, 1);
      }
      const updatedArray = filterArray.map(({ level, ...rest }, index) => {
        return { level: index, ...rest };
      });
      setTripApprovalData([...updatedArray]);
    }
  };

  return (
    <>
      {showApproval ? (
        <Tabs
          onChange={setTab}
          type="card"
          size="large"
          className="custom-tabs"
        >
          <TabPane tab={t("hierarchy_approval")} key="preferences">
            <div className="tabContentWrapper">
              {showAdvancedApproval ? (
                <AdvancedApproval
                  type={"TRIP"}
                  inv_type={"TRIP_APPROVAL"}
                  approvalData={tripApprovalData}
                  hasWriteAccess={hasWriteAccess}
                />
              ) : (
                <HirarchicalApproval
                  approvalData={tripApprovalData}
                  setApprovalData={setTripApprovalData}
                  editMode={editMode}
                  handleList={handleApproveList}
                  selectedRoles={selectedRoles}
                  setSelectedRoles={setSelectedRoles}
                  rolesData={rolesData}
                  hirarchicalApprovalCheckBoxTitle="trips"
                  hasWriteAccess={hasWriteAccess}
                />
              )}
              {editMode &&
                rolesData?.filter(
                  (ele) =>
                    ele.role_name !== "Admin" &&
                    !tripApprovalData
                      ?.filter((ele) => ele.is_active !== false)
                      ?.map((ele) => ele.role_id)
                      ?.includes(ele.id)
                )?.length > 0 && (
                  <Button
                    disabled={!editMode || !hasWriteAccess}
                    type="default"
                    ghost
                    className="approve-add-btn mt1"
                    onClick={() => handleApproveList("add")}
                  >
                    {t("add_one_more")}
                  </Button>
                )}
              <div className="floatBottom">
                <>
                  {!editMode && !showAdvancedApproval && (
                    <Button
                      disabled={!hasWriteAccess}
                      className="formButton mt1 primaryButton"
                      onClick={() => setEditMode(true)}
                    >
                      {t("edit")}
                    </Button>
                  )}
                  {!editMode && (
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => {
                        setShowApproval(false);
                      }}
                    >
                      {t("back")}
                    </Button>
                  )}
                </>

                {editMode && (
                  <>
                    <Button
                      disabled={!hasWriteAccess}
                      key="1"
                      className="formButton mt1 primaryButton"
                      onClick={() => handleSubmit()}
                    >
                      {t("save")}
                    </Button>
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => handleCancel()}
                    >
                      {t("cancel")}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </TabPane>
        </Tabs>
      ) : (
        <div className="tabContentWrapper">
          <h3>{t("approval_types")}</h3>
          <Radio.Group
            className="w100"
            onChange={(e) => {
              setRadioVal(e.target.value);
            }}
            value={radioVal}
            disabled={!hasWriteAccess}
          >
            <div
              className={`hierarchical-select ${
                radioVal === "hierarchical" ? "active" : ""
              }`}
              onClick={() => {
                if (hasWriteAccess) {
                  setRadioVal("hierarchical");
                  updateOptions({
                    data: {
                      seed_type: "trips_hierarchy",
                      seed_code: "TRP_1",
                      is_active: true,
                    },
                    // params:{
                    //   module_type: "TRIP_APPROVAL"
                    // }
                  });
                }
              }}
            >
              <Radio
                disabled={!hasWriteAccess}
                name="hierarchical"
                checked={radioVal === "hierarchical"}
                value={"hierarchical"}
              />
              <div>
                <span>{t("hierarchy_approval")}</span>
                <span>{t("approval_flow")}</span>
                {radioVal === "hierarchical" ? (
                  <ArrowRightOutlined
                    onClick={() => {
                      setShowApproval(true);
                    }}
                  />
                ) : null}
              </div>
            </div>
            <div
              className={`hierarchical-select ${
                radioVal === "advanced" ? "active" : ""
              }`}
              onClick={() => {
                if (hasWriteAccess) {
                  setRadioVal("advanced");
                  updateOptions({
                    data: {
                      seed_type: "trips_hierarchy",
                      seed_code: "TRP_2",
                      is_active: true,
                    },
                  });
                }
              }}
            >
              <Radio
                disabled={!hasWriteAccess}
                name="advanced"
                checked={radioVal === "advanced"}
                value={"advanced"}
              />
              <div>
                <span>Advanced Approval</span>
                <span>
                  You can set up an approval flow based on one or more criteria.
                  These criteria can be chosen by you.
                </span>
                {radioVal === "advanced" ? (
                  <ArrowRightOutlined
                    onClick={() => {
                      setShowAdvancedApproval(true);
                      setShowApproval(true);
                    }}
                  />
                ) : null}
              </div>
            </div>
          </Radio.Group>
        </div>
      )}
    </>
  );
};

export default ApprovalTrip;
